module.exports = new __parcel__URL__("Sequelize.f7327785.svg").toString();